export default [
  {
    path: '/notification-management',
    name: 'notificationData',
    component: () => import('@/views/apps/admins/NotificationManagement'),
    meta: {
      resource: 'marketing',
      action: 'manage',
    },
  },
  {
    path: '/notification-setting',
    name: 'notificationSetting',
    component: () => import('@/views/apps/admins/notification-setting/NotificationSetting.vue'),
    meta: {
      resource: 'marketing',
      action: 'manage',
    },
  },
]
